import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
// import { API_URL } from '../../config/config';  

const API_URL = process.env.REACT_APP_API_URL;


// Fetch activity data for the user (existing thunk)
export const fetchActivityData = createAsyncThunk(
  'activity/fetchActivityData',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/activity/activities/${userId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || error.message);
    }
  }
);

// New thunk to fetch today's activity data
export const fetchTodaysActivityData = createAsyncThunk(
  'activity/fetchTodaysActivityData',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/activity/Todaysactivities/${userId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || error.message);
    }
  }
);

// Initial state
const initialState = {
  alldata: [], // All activity data for the chart
  todaysData: [], // Store today's activity data for the chart
  currentActivity: 'inactive', // Default to inactive
  lastSeen: null, // Last active timestamp (stored as ISO string)
  status: 'idle',
  error: null,
};

const activitySlice = createSlice({
  name: 'activity',
  initialState,
  reducers: {
    clearDataPoints: (state) => {
      state.alldata = [];
    },
    clearCurrentActivity: (state) => {
      state.currentActivity = 'inactive';
      state.lastSeen = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle activity data fetching
      .addCase(fetchActivityData.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchActivityData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.alldata = action.payload;

        if (action.payload.length > 0) {
          const latestActivity = action.payload[action.payload.length - 1];
          const lastSeenTime = new Date(latestActivity.time);
          const currentTime = new Date();

          const timeDiffInMinutes = (currentTime - lastSeenTime) / 1000 / 60;

          state.currentActivity = timeDiffInMinutes <= 10 ? 'active' : 'inactive';
          state.lastSeen = lastSeenTime.toISOString(); // Store as ISO string
        } else {
          state.currentActivity = 'inactive';
        }
      })
      .addCase(fetchActivityData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      // Handle today's activity data fetching
      .addCase(fetchTodaysActivityData.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchTodaysActivityData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.todaysData = action.payload;
      })
      .addCase(fetchTodaysActivityData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { clearDataPoints, clearCurrentActivity } = activitySlice.actions;

export default activitySlice.reducer;
